import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { SharedService } from './shared.service';

@Injectable({
  providedIn: 'root'
})
export class ValuesService {

  constructor(private http: HttpClient) { }

  now() {
    return this.http.get<number>(environment.app.apiUrl + 'values/now').toPromise();
  }

  homepage() {
    return this.http.get<any>(environment.app.apiUrl + 'values/homepage', { context: SharedService.NO_LOADING_BAR }).toPromise();
  }

  request() {
    return this.http.get<any>(environment.app.apiUrl + 'values/request').toPromise();
  }
  
  error(local = true) {
    if (local) throw 'test error';
  }
  
  serverError(type: string, message?: string) {
    return this.http.get(environment.app.apiUrl + `values/error/${type}/${message || ''}`).toPromise();
  }

}
